import { render, staticRenderFns } from "./LazyProductCard.vue?vue&type=template&id=296125f8&"
import script from "./LazyProductCard.vue?vue&type=script&lang=js&"
export * from "./LazyProductCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/induline.salamander.live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('296125f8')) {
      api.createRecord('296125f8', component.options)
    } else {
      api.reload('296125f8', component.options)
    }
    module.hot.accept("./LazyProductCard.vue?vue&type=template&id=296125f8&", function () {
      api.rerender('296125f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/cards/LazyProductCard.vue"
export default component.exports